/* eslint-disable react/no-multi-comp, max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const ERROR_CODES = {
    LEADERBOARDS_NOT_AVAILABLE: 'leaderboards_not_available',
    UNKNOWN_ERROR: 'UNKNOWN_ERROR',
    GET_REWARD_ERROR: 'GET_REWARD_ERROR',
}

export default {
    [ERROR_CODES.GET_REWARD_ERROR]: {
        title: (
            <FormattedMessage
                id='wgcwx_leaderboards.get_reward_error.title'
                defaultMessage='Ошибка при перечислении средств на счёт'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_leaderboards.get_reward_error.description'
                defaultMessage='Не удалось начислить награду. Повторите попытку позже.'
            />
        ),
    },
    [ERROR_CODES.LEADERBOARDS_NOT_AVAILABLE]: {
        title: (
            <FormattedMessage
                id='wgcwx_leaderboards.leaderboards_are_not_available.title'
                defaultMessage='Достижения в событии временно недоступны'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_leaderboards.leaderboards_are_not_available.description'
                defaultMessage='Попробуйте зайти на страницу позже.'
            />
        ),
    },
    [ERROR_CODES.UNKNOWN_ERROR]: {
        title: (
            <FormattedMessage
                id='wgcwx_leaderboards.leaderboards_data_loading_error.title'
                defaultMessage='Не удалось отобразить достижения в событии'
            />
        ),
        description: (
            <FormattedMessage
                id='wgcwx_leaderboards.leaderboards_data_loading_error.description'
                defaultMessage='Достижения в событии временно недоступны. Попробуйте зайти на страницу позже.'
            />
        ),
    },
}



// WEBPACK FOOTER //
// ./containers/WGCWXLeaderboards/components/Error/errors.js